export default __webpack_public_path__ + "static/media/video2.30911531.webp";